import { searchContent as apiSearchContent } from '../util/api';

// Action types
export const FETCH_GLOBAL_SEARCH_REQUEST = 'app/globalSearch/FETCH_REQUEST';
export const FETCH_GLOBAL_SEARCH_SUCCESS = 'app/globalSearch/FETCH_SUCCESS';
export const FETCH_GLOBAL_SEARCH_ERROR = 'app/globalSearch/FETCH_ERROR';

// Initial state
export const initialState = {
  q: '',
  results: [],
  counts: {},
  inProgress: false,
  error: null,
  hasMore: false,
};

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_GLOBAL_SEARCH_REQUEST:
      return { ...state, inProgress: true, error: null, q: payload?.q || '' };
    case FETCH_GLOBAL_SEARCH_SUCCESS: {
      const append = !!payload?.append;
      const nextResults = append
        ? [...(state.results || []), ...(payload?.results || [])]
        : payload?.results || [];
      return {
        ...state,
        inProgress: false,
        error: null,
        results: nextResults,
        counts: payload?.counts || {},
        hasMore: !!payload?.hasMore,
      };
    }
    case FETCH_GLOBAL_SEARCH_ERROR:
      return { ...state, inProgress: false, error: payload || 'Search failed' };
    default:
      return state;
  }
}

// Action creators
export const fetchGlobalSearchRequest = q => ({
  type: FETCH_GLOBAL_SEARCH_REQUEST,
  payload: { q },
});
export const fetchGlobalSearchSuccess = data => ({
  type: FETCH_GLOBAL_SEARCH_SUCCESS,
  payload: data,
});
export const fetchGlobalSearchError = e => ({ type: FETCH_GLOBAL_SEARCH_ERROR, payload: e });

// Thunk
export const searchAllContent = ({
  q,
  defaultLocale,
  limit = 10,
  offset = 0,
  append = false,
}) => async (dispatch, getState) => {
  dispatch(fetchGlobalSearchRequest(q));
  try {
    const resp = await apiSearchContent({ q, defaultLocale, limit, offset });
    dispatch(fetchGlobalSearchSuccess({ ...(resp || {}), append }));
    return resp;
  } catch (e) {
    dispatch(fetchGlobalSearchError(e?.message || 'Search failed'));
    return null;
  }
};
